import React from 'react';
import { motion } from 'framer-motion';
export function ModeloNegocioSection() {
  const cards = [{
    icon: '📈',
    title: 'El mercado digital no para de crecer',
    text: 'Cada vez más personas compran educación online, guías y conocimientos que les ayuden a resolver problemas específicos. Los productos digitales son uno de los mercados que más crece en internet.'
  }, {
    icon: '📚',
    title: 'Un ebook es el producto digital más simple',
    text: 'No necesitás grabar cursos, tener seguidores ni equipos. Con un ebook podés empaquetar tu conocimiento en un producto claro, valioso y fácil de vender.'
  }, {
    icon: '⚡',
    title: 'Las ventas pueden ser automáticas',
    text: 'Con una tienda digital y campañas de anuncios, las personas descubren tu ebook y lo compran automáticamente. Tu tienda vende 24/7 sin depender de redes sociales o mensajes.'
  }];
  return <section className="w-full bg-white pt-2 md:pt-4 pb-10 md:pb-14 px-6" data-id="element-336">
      <div className="max-w-6xl mx-auto" data-id="element-337">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16 relative" data-id="element-338">
          <div className="absolute left-1/2 -translate-x-1/2 top-[-20%] w-[800px] h-[600px] bg-[#22c55e]/[0.14] rounded-full blur-[120px] pointer-events-none" data-id="element-339" />
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 leading-tight relative z-10 mb-6" data-id="element-340">
            ¿Por qué este modelo de
            <br data-id="element-341" />
            <span className="text-[#1fa855]" data-id="element-342">negocio</span> funciona hoy?
          </h2>
          <p className="text-lg md:text-xl text-gray-500 max-w-3xl mx-auto leading-relaxed" data-id="element-343">
            Estamos en el mejor momento de la historia para vender conocimiento
            online. Miles de personas ya están monetizando lo que saben con
            productos digitales simples.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-344">
          {cards.map((card, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="bg-[#159A5A] rounded-2xl p-8 md:p-10 text-center shadow-lg shadow-green-900/10 flex flex-col items-center" data-id="element-345">
              <div className="text-4xl md:text-5xl mb-6 drop-shadow-sm" data-id="element-346">
                {card.icon}
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-4 leading-snug" data-id="element-347">
                {card.title}
              </h3>
              <p className="text-white/90 text-base leading-relaxed" data-id="element-348">
                {card.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}